import { Select, SelectOption } from '@acp/core-ui';
import React, { useMemo } from 'react';
import { Props } from 'chakra-react-select';
import { useDocumentTypes } from '../hooks';

type DocumentTypeOption = SelectOption<string>;

function DocumentTypeSelect({
    value,
    onChange,
    size,
}: {
    onChange: Props<DocumentTypeOption, false>['onChange'];
    value: string | null;
    size?: React.ComponentProps<typeof Select>['size'];
}) {
    const documentTypesQuery = useDocumentTypes();

    const options = useMemo(() => {
        if (documentTypesQuery.isLoading) {
            return [];
        }

        const documentTypes = documentTypesQuery.data ?? [];

        return documentTypes.map((documentType) => ({
            label: documentType.name,
            value: documentType.code,
        }));
    }, [documentTypesQuery.data, documentTypesQuery.isLoading]);

    const selectedOption = useMemo(
        () => options.find((option) => option.value === value),
        [options, value]
    );

    return (
        <Select<DocumentTypeOption, false>
            options={options}
            onChange={onChange}
            value={selectedOption}
            isLoading={documentTypesQuery.isLoading}
            placeholder="Select document type"
            isMulti={false}
            size={size}
        />
    );
}

export { DocumentTypeSelect, DocumentTypeOption };
